import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import spinner from "../../../assets/spinner4.svg";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import moment from "moment/moment";
import { actualizarMascota, crearMascota, guardarImagenMascota } from "../../../api/api-mascota";
import LoadingComponent from "../../../components/loading-component";
import { obtenerDepartamentos } from "../../../api/api-departamento";
// import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
// import { countNombreEmpresaPlataforma, countUsernameUsuarioPlataforma, registrarEmpresaPlataforma } from "../../../api/api-empresa-plataforma";
import Select from "react-select";
import { compressAndConvertToBase64 } from "../../../utils/shared-functions";
import ImageUploaderImages from "../../../components/image-uploader-images";

export default function Mascota() {
    const location = useLocation();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [modalLoadingVisible, setModalLoadingVisible] = useState(false);
    const [title, setTitle] = useState("");
    const [cargandoPage, setCargandoPage] = useState(true);
    const [formData, setFormData] = useState({
        nombre: '',
        raza: '',
        color: '',
        edad: "",
        idDepartamento: null,
    });
    const [images, setImages] = useState([]);
    const [listaDepartamentos, setListaDepartamentos] = useState([]);
    const [departamentoSelected, setDepartamentoSelected] = useState(null);

    const charLimits = {
        nombre: 64,
        raza: 32,
        color: 16,
        edad: 32,
    };

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const data = location.state;
            // console.log("data");
            // console.log(data);
            if (data !== undefined && data !== null) {
                setFormData(data.params);
                setTitle(data.titulo);
                if (data.params.imagenes !== undefined) {
                    const imagenes = JSON.parse(data.params.imagenes);
                    setImages(imagenes);
                }
            }
            // const response = await obtenerInfoEmpresa();
            // console.log('response');
            // console.log(response);
            // setFormData(response.body);
            const response = await obtenerDepartamentos();
            // console.log('response');
            // console.log(response);
            if (response.error === false) {
                setListaDepartamentos(response.body);
                if (data.params.idDepartamento !== undefined && data.params.idDepartamento !== null) {
                    const departamento = response.body.filter((item) => item.value === data.params.idDepartamento);
                    if (departamento.length > 0) {
                        setDepartamentoSelected(departamento[0]);
                    }
                }
            }
            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const handleAtrasClick = () => {
        history.goBack();
    };

    const validar = () => {
        try {
            let result = { error: true, message: "" };
            let message = "";
            if (formData.nombre.trim().length === 0) {
                message = message + "Debe ingresar nombre" + "\n";
            }
            if (formData.raza.trim().length === 0) {
                message = message + "Debe ingresar raza" + '\n';
            }
            if (formData.color.trim().length === 0) {
                message = message + "Debe ingresar color" + '\n';
            }
            if (formData.edad.trim().length === 0) {
                message = message + "Debe ingresar Edad" + '\n';
            }
            if (departamentoSelected === null) {
                message = message + "Debe Seleccionar departamento" + '\n';
            }
            if (message.length > 0) {
                result.error = true;
                result.message = message;
            } else {
                result.error = false;
            }
            return result;
        } catch (err) {
            return { error: true, message: err };
        }
    };

    const handleOnClickGuardar = async () => {
        try {
            setLoading(true);
            setModalLoadingVisible(true);
            const isValid = validar();
            if (isValid.error === true) {
                setModalLoadingVisible(false);
                alert(isValid.message);
                return;
            }
            // return;
            let objEnviar = {};
            objEnviar.id = formData.id;
            objEnviar.nombre = formData.nombre;
            objEnviar.raza = formData.raza;
            objEnviar.color = formData.color;
            objEnviar.edad = formData.edad;
            objEnviar.images = images;
            objEnviar.idDepartamento = departamentoSelected.value;
            // console.log('objEnviar');
            // console.log(objEnviar);
            if (objEnviar.id === 0) {
                // console.log('actualizar correo');
                const response = await crearMascota(objEnviar);
                setModalLoadingVisible(false);
                // console.log('modificado');
                // console.log(modificado);
                if (response.error === false) {
                    alert('Se creo correctamente');
                    handleAtrasClick();
                }
                if (response.error === true) {
                    alert('No se pudo crear\n' + response.message);
                }
            }
            if (objEnviar.id !== 0) {
                // console.log('actualizar mascota');
                const response = await actualizarMascota(objEnviar);
                setModalLoadingVisible(false);
                // console.log('modificado');
                // console.log(modificado);
                if (response.error === false) {
                    alert('Se modifico correctamente');
                    handleAtrasClick();
                }
                if (response.error === true) {
                    alert('No se pudo modificar\n' + response.message);
                }
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
        }
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file) {
            convertToBase64(file);
        }
    };

    const handleFileSelect = (event) => {
        // console.log("File input event:", event);
        if (!event.target.files) {
            alert("No files detected in event.target.files.");
            return;
        }

        const file = event.target.files[0];
        // console.log("Selected file:", file);

        if (file) {
            convertToBase64(file);
        } else {
            alert("No file selected.");
        }
    };

    // Convert image file to Base64
    const convertToBase64 = (file) => {
        const MAX_SIZE = 5 * 1024 * 1024; // 1MB in bytes

        if (file.size > MAX_SIZE) {
            alert("The image is bigger than the allowed size (" + MAX_SIZE + "MB). Please select a smaller file.");
            return;
        }
        compressAndConvertToBase64(file, (base64String) => {
            uploadImage(base64String);
        });
    };

    const uploadImage = async (file) => {
        try {
            // console.log('uploadImage');
            // console.log(file);
            setModalLoadingVisible(true);
            let objEnviar = {};
            objEnviar.base64 = file;
            objEnviar.nombre = moment().unix() + '.png';
            objEnviar.tipoArchivo = ".png";
            const response = await guardarImagenMascota(objEnviar);
            // console.log('response');
            // console.log(response);
            if (response.error === false) {
                setImages([...images, response.body.url_fotografia]); // Assuming API returns { imageUrl: "http://your-api.com/uploads/image.jpg" }
            } else {
                alert("Upload failed");
            }
            setModalLoadingVisible(false);
        } catch (error) {
            console.error("Error uploading image:", error);
            setModalLoadingVisible(false);
        }
    };

    const deleteImage = async (imageUrl) => {
        try {
            setImages(images.filter((img) => img !== imageUrl));
        } catch (error) {
            console.error("Error deleting image:", error);
        }
    };

    const render = () => {
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (cargandoPage === false && formData === null) {
                return (
                    <div>
                        <label> Sin data</label>
                    </div>
                );
            }
            return (
                <div className="p-4">
                    <h2 className="text-2xl font-bold text-[#0F3457] mb-6">{title}</h2>
                    <div class="grid grid-cols-12 gap-4">
                        <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nameCompany">
                                    Nombre
                                </label>
                                <input
                                    type="text"
                                    id="nombre"
                                    name="nombre"
                                    value={formData.nombre}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Nombre"
                                    maxLength={charLimits.nombre}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.nombre.length}/{charLimits.nombre}</p>
                            </div>
                        </div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="raza">
                                    Raza<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="raza"
                                    name="raza"
                                    value={formData.raza}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Raza"
                                    maxLength={charLimits.raza}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.raza.length}/{charLimits.raza}</p>
                            </div>
                        </div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="color">
                                    Color<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="color"
                                    name="color"
                                    value={formData.color}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Color"
                                    maxLength={charLimits.color}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.color.length}/{charLimits.color}</p>
                            </div>
                        </div>
                        <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="edad">
                                    Edad<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="edad"
                                    name="edad"
                                    value={formData.edad}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Edad"
                                    maxLength={charLimits.edad}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.edad.length}/{charLimits.edad}</p>
                            </div>
                        </div>
                    </div>
                    <div class="grid grid-cols-12 gap-4">
                        <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="departamento">
                                Departamento<span className="text-red-500">*</span>
                            </label>
                            <Select
                                options={listaDepartamentos}
                                isSearchable={true}
                                isClearable={true}
                                value={departamentoSelected}
                                onChange={(event) => { setDepartamentoSelected(event); }}
                                placeholder={"Seleccione Departamento"}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                    </div>
                    <div class="grid grid-cols-12 gap-4">
                        <div class="col-span-12">
                            <div className="max-w-lg mx-auto p-6">
                                {/* Drag and Drop Area */}
                                {/* <div
                                    className="border-2 border-dashed border-gray-400 p-10 text-center cursor-pointer"
                                    onDrop={handleDrop}
                                    onDragOver={(e) => e.preventDefault()}
                                >
                                    <p className="text-gray-600">Drag & Drop an image or</p>
                                    <input type="file" className="hidden" onChange={handleFileSelect} id="fileInput" />
                                    <label htmlFor="fileInput" className="bg-blue-500 text-white px-4 py-2 rounded cursor-pointer mt-2 inline-block">
                                        Select File
                                    </label>
                                </div> */}

                                {/* Uploaded Images List */}
                                {/* <div className="mt-4">
                                    {images.map((image, index) => (
                                        <div key={index} className="flex items-center justify-between p-2 border rounded mt-2">
                                            <img src={image} alt="Uploaded" className="w-16 h-16 object-cover rounded" />
                                            <button className="bg-red-500 text-white px-2 py-1 rounded" onClick={() => deleteImage(image)}>
                                                Delete
                                            </button>
                                        </div>
                                    ))}
                                </div> */}
                                <ImageUploaderImages
                                    handleDrop={handleDrop}
                                    handleFileSelect={handleFileSelect}
                                    images={images}
                                    deleteImage={deleteImage}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-between">
                        <button
                            onClick={handleAtrasClick}
                            className="text-center text-[#0F3457] mt-4 cursor-pointer hover:underline"
                        >
                            Atras
                        </button>
                        {loading === false &&
                            <button
                                className="bg-[#84B044] text-white font-semibold py-2 px-4 rounded-lg hover:bg-[#6f9239] transition duration-300"
                                onClick={handleOnClickGuardar}
                            >
                                Guardar
                            </button>
                        }
                        {loading === true &&
                            <button
                                className="bg-[#84B044] text-white font-semibold py-2 px-4 rounded-lg hover:bg-[#6f9239] transition duration-300 flex justify-center items-center"
                            >
                                <img className="spinner" alt="spinner" src={spinner} />
                            </button>
                        }
                    </div>
                    <LoadingComponent
                        isOpen={modalLoadingVisible}
                    />
                </div >
            );
        } catch (err) {
            console.log('Empresa render err');
            console.log(err);
            return (
                <div>
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }

    return render();
}
